import { ItemList } from '../../orm'

class AdminTopupList extends ItemList {
    getEntityKey() {
        return "admin/topup"
    }
}

export const adminTopupList = new AdminTopupList("admin_topup__default")
